import { useEffect, useRef, useState } from "react";

import Image from "./Image";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Carousel.module.css";
import { useInterval } from "../utils/hooks";

export default function Carousel({ className = "", items }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const imagesLoaded = useRef(0);
  const { clearInterval, startInterval } = useInterval(() => {
    setActiveIndex(activeIndex + 1);
  }, 800);
  useEffect(() => {
    return () => {
      clearInterval();
    };
  }, []);

  return (
    <div
      className={classNames(className, styles.Carousel)}
      style={{
        "--aspect": `${(9 / 16) * 100}%`,
      }}
    >
      <div className={styles.slides}>
        {items.map((item, index) => {
          const itemIsActive = activeIndex % items.length === index;
          const itemIsPrevActive = (activeIndex - 1) % items.length === index;
          const classes = classNames({
            [styles.slide]: true,
            [styles.active]: itemIsActive,
            [styles.prevActive]: itemIsPrevActive,
          });
          return (
            <Image
              key={index}
              className={classes}
              src={item.src}
              srcSet={item.srcSet}
              sizes="100vw"
              alt={item.title}
              width={800}
              height={450}
              fadeInOnLoad={index === 0}
              handleLoaded={() => {
                imagesLoaded.current += 1;
                if (imagesLoaded.current === items.length) {
                  // Allow fade in to happen before starting interval
                  setTimeout(() => {
                    startInterval();
                  }, 500);
                }
              }}
            ></Image>
          );
        })}
      </div>
    </div>
  );
}

Carousel.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
